import { useEffect, useState } from 'react';
import { buildMonthGrid, formatFullDateJP, formatMonthLabel, sameDate } from '../../utils/dateUtils';

const WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'];

/**
 * Collapsible date field used inside EventFormSheet: a trigger button
 * showing the formatted date, expanding into an inline month
 * calendar (reusing the same grid layout as the home screen's
 * CalendarMonth) instead of a native <input type="date">.
 */
export default function DateInlineCalendar({ value, onChange, today }) {
  const [open, setOpen] = useState(false);
  const [viewYear, setViewYear] = useState(value.getFullYear());
  const [viewMonth, setViewMonth] = useState(value.getMonth());

  // Re-center the mini calendar on the current value whenever it opens.
  useEffect(() => {
    if (open) {
      setViewYear(value.getFullYear());
      setViewMonth(value.getMonth());
    }
  }, [open, value]);

  const grid = buildMonthGrid(viewYear, viewMonth);

  const goPrevMonth = () => {
    if (viewMonth === 0) {
      setViewMonth(11);
      setViewYear((y) => y - 1);
    } else {
      setViewMonth((m) => m - 1);
    }
  };

  const goNextMonth = () => {
    if (viewMonth === 11) {
      setViewMonth(0);
      setViewYear((y) => y + 1);
    } else {
      setViewMonth((m) => m + 1);
    }
  };

  const handlePick = (day) => {
    onChange(day);
    setOpen(false);
  };

  return (
    <div className="field">
      <label>日付</label>
      <button type="button" className={`date-trigger${open ? ' open' : ''}`} onClick={() => setOpen((o) => !o)}>
        <span className="dt-icon">📅</span>
        <span className="dt-text">{formatFullDateJP(value)}</span>
        <span className={`dt-chevron${open ? ' rotated' : ''}`}>▾</span>
      </button>

      <div className={`inline-cal-panel${open ? ' open' : ''}`}>
        <div className="calendar-header" style={{ padding: '10px 4px 8px' }}>
          <div className="nav">
            <button type="button" onClick={goPrevMonth}>‹</button>
          </div>
          <div className="month-label">{formatMonthLabel(viewYear, viewMonth)}</div>
          <div className="nav">
            <button type="button" onClick={goNextMonth}>›</button>
          </div>
        </div>
        <div className="weekday-row">
          {WEEKDAYS.map((w) => (
            <span key={w}>{w}</span>
          ))}
        </div>
        <div className="day-grid">
          {grid.map((day) => {
            const isOtherMonth = day.getMonth() !== viewMonth;
            const isToday = sameDate(day, today);
            const isSelected = sameDate(day, value);
            return (
              <div
                key={day.toISOString()}
                className={['day-cell', isOtherMonth && 'other-month', isToday && 'today', isSelected && 'selected']
                  .filter(Boolean)
                  .join(' ')}
                onClick={() => handlePick(day)}
              >
                <div className="num">{day.getDate()}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
